import React from 'react';
import styled, { keyframes } from 'styled-components';
import Downshift from 'downshift';
import { Manager, Reference, Popper } from 'react-popper';
import operational from 'images/operational.svg';
import cross from 'images/cross.svg';
import caution from 'images/caution.svg';
import maintenance from 'images/maintenance.svg';
import degraded from 'images/degraded.svg';
import Icon from '../../Icons';

const itemToString = item => (item === null ? '' : String(item.id));

export const STATUSES = {
  OP: 'Operational',
  PD: 'Degraded Performance',
  UM: 'Under Maintenance',
  PO: 'Partial Outage',
  MO: 'Major Outage'
};

export const items = [
  {
    id: 'OP',
    icon: 'Operational',
    label: 'Operational'
  },
  {
    id: 'PD',
    icon: 'Degraded',
    label: 'Degraded Performance'
  },
  {
    id: 'UM',
    icon: 'Maintenance',
    label: 'Under Maintenance'
  },
  {
    id: 'PO',
    icon: 'Partial',
    label: 'Partial Outage'
  },
  {
    id: 'MO',
    icon: 'Major',
    label: 'Major Outage'
  }
];

const StatusSelect = ({
  component,
  selectedItem = items[1].id,
  onChange,
  affected,
  isPlanned,
  isActive = true,
  isQuickChange
}) => {
  // const statuses = affected ? items.slice(1) : items;
  const statuses = items;
  return (
    <StatusSelection isActive={isActive} isQuickChange={isQuickChange}>
      <Downshift itemToString={itemToString}>
        {({ getItemProps, isOpen, toggleMenu, getMenuProps }) => (
          <div style={{ margin: 'auto', width: '200px' }}>
            <Manager>
              <span>
                <Reference>
                  {({ ref }) => (
                    <div ref={ref}>
                      <MenuButton
                        activeItem={
                          isPlanned && isActive
                            ? { id: STATUSES.UM }
                            : selectedItem
                        }
                        isActive={isActive}
                        isQuickChange={isQuickChange}
                        onClick={toggleMenu}
                      >
                        {isPlanned && isActive
                          ? STATUSES.UM
                          : STATUSES[selectedItem.id]}
                        {!isPlanned && <Icon size={12} glyph="arrowdown" />}
                      </MenuButton>
                    </div>
                  )}
                </Reference>
              </span>
              {isOpen && isActive && !isPlanned ? (
                <Popper placement="bottom">
                  {({ ref, style, scheduleUpdate }) => (
                    <DropdownMenu ref={ref} style={style}>
                      {statuses.map((item, index) => (
                        <div
                          className={`item ${item.icon}`}
                          key={item.id}
                          onClick={() => {
                            onChange({
                              state: item.id,
                              component: component.component
                            });
                            toggleMenu();
                          }}
                        >
                          {STATUSES[item.id]}
                        </div>
                      ))}
                    </DropdownMenu>
                  )}
                </Popper>
              ) : null}
            </Manager>
          </div>
        )}
      </Downshift>
    </StatusSelection>
  );
};

export default StatusSelect;

const StatusSelection = styled.div`
  position: relative;

  border-radius: 4px;
  background-color: ${props => (props.isActive ? '#ffffff' : '#edeff3')};
  border: ${props => (props.isActive ? 'solid 1px #e4e2e2' : '0')}
  color: #0082ff;
  cursor: ${props => (props.isActive ? 'pointer' : 'not-allowed')};
`;

export const moveDownKeyframe = keyframes`
from {top:5px; opacity: 0;}
to {top:32px; opacity: 1}
`;

export const DropdownMenu = styled.div`
  position: absolute;
  display: block;
  z-index: 999;
  background: #fff;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05), 0 1px 4px rgba(0, 0, 0, 0.15);
  border: 0;
  padding: 0;
  width: 200px;
  // top: 49px;
  border-radius: 2px;
  border-top: 1px #ebeef0 solid;
  text-align: center;
  // animation: ${moveDownKeyframe} 0.3s ease 0s 1 normal forwards running;

  .item {
    text-align: left;
    position: relative;
    font-size: 13px;
    line-height: 2;
    font-weight: 400;
    color: #48545c;
    padding: 7px 10px 9px 40px;

    &:before {
      content: '';
      width: 16px;
      height: 16px;
      display: block;
      position: absolute;
      top: 10px;
      left: 10px;
    }

    &.Operational {
      &:before {
        background: url(${operational}) no-repeat center;
        background-size: 14px;
      }
    }
    &.Maintenance {
      &:before {
        background: url(${maintenance}) no-repeat center;
        background-size: 14px;
      }
    }
    &.Major {
      &:before {
        background: url(${cross}) no-repeat center;
        background-size: 14px;
      }
    }
    &.Partial {
      &:before {
        background: url(${caution}) no-repeat center;
        background-size: 14px;
      }
    }
    &.Degraded {
      &:before {
        background: url(${degraded}) no-repeat center;
        background-size: 14px;
      }
    }

    &:hover {
      background: #ececff;
      cursor: pointer;
    }
  }
`;

export const ControlButton = styled.div`
  height: 100%;
  line-height: 27px;
  font-size: 14px;
  font-weight: 600;
  color: #52708d;
`;

export const STATE_COLORS_OPTIONS = {
  OP: '#20ba4a',
  PD: '#f1c40e',
  UM: '#0082ff',
  PO: '#e67e21',
  MO: '#ff6060'
};

export const MenuButton = styled.div`
  height: 28px;
  line-height: 29px;
  padding: 0 10px;
  font-weight: 600;
  position: relative;
  font-size: 13px;
  letter-spacing: 0px;
  color: ${props =>
    props.isActive
      ? STATE_COLORS_OPTIONS[props.activeItem.id]
      : 'rgba(34,34,34,0.3)'};
  padding-right: 30px;
  > div {
    position: absolute;
    top: 8px;
    right: 8px;
    color: #333;
  }
  &:hover {
    color: ${props =>
      props.isActive
        ? STATE_COLORS_OPTIONS[props.activeItem.id]
        : 'rgba(34,34,34,0.3)'};
  }
`;
